import { createContext, useState, useContext, useEffect } from "react";
import { useCookies } from "react-cookie";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [cookies, setCookie, removeCookie] = useCookies(["refresh", "token", "role", "email", "isratp", "id"]);
  const [refresh, setRefresh] = useState(cookies.refresh || false);
  const [token, setToken] = useState(cookies.token || "");
  const [role, setRole] = useState(cookies.role || "");
  const [email, setEmail] = useState(cookies.email || "");
  const [isratp, setisratp] = useState(cookies.isratp || "");
  const [id, setId] = useState(cookies.id || "");

  const initializeUserCookies = () => {
    if (!cookies.refresh) setCookie("refresh", false, { path: "/", sameSite: "Lax" });
    if (!cookies.token) setCookie("token", "", { path: "/", sameSite: "Lax" });
    if (!cookies.role) setCookie("role", "", { path: "/", sameSite: "Lax" });
    if (!cookies.email) setCookie("email", "", { path: "/", sameSite: "Lax" });
    if (!cookies.isratp) setCookie("isratp", "", { path: "/", sameSite: "Lax" });
    if (!cookies.id) setCookie("id", "", { path: "/", sameSite: "Lax" });
  };

  useEffect(() => {
    initializeUserCookies();
  }, []);

  useEffect(() => {
    if (refresh !== undefined) setCookie("refresh", refresh, { path: "/", sameSite: "Lax" });
    if (token !== undefined) setCookie("token", token, { path: "/", sameSite: "Lax" });
    if (role !== undefined) setCookie("role", role, { path: "/", sameSite: "Lax" });
    if (email !== undefined) setCookie("email", email, { path: "/", sameSite: "Lax" });
    if (isratp !== undefined) setCookie("isratp", isratp, { path: "/", sameSite: "Lax" });
    if (id !== undefined) setCookie("id", id, { path: "/", sameSite: "Lax" });
  }, [refresh, token, role, email, isratp, id, setCookie]);

  const refreshPage = (newRefresh) => {
    setRefresh(newRefresh);
  };

  const setUserData = (newId, newToken, newRole, newEmail, newIsratp) => {
    setToken(newToken);
    setRole(newRole);
    setEmail(newEmail);
    setisratp(newIsratp);
    setId(newId);
  };

  const clearUserData = () => {
    setToken("");
    setRole("");
    setEmail("");
    setisratp("");
    setRefresh(false);
    setId("");

    removeCookie("token", { path: "/", sameSite: "Lax" });
    removeCookie("role", { path: "/", sameSite: "Lax" });
    removeCookie("email", { path: "/", sameSite: "Lax" });
    removeCookie("refresh", { path: "/", sameSite: "Lax" });
    removeCookie("isratp", { path: "/", sameSite: "Lax" });
    removeCookie("id", { path: "/", sameSite: "Lax" });
  };

  return (
    <UserContext.Provider
      value={{
        refresh,
        token,
        role,
        email,
        isratp,
        id,
        refreshPage,
        setUserData,
        clearUserData,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
